import logo from './logo.svg';
import './App.css';
import ProductListComponent from './ProductList'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <ProductListComponent />
      </header>
    </div>
  );
}

export default App;
